<template>
  <div class="col-md my-auto text-center">
    <div class="row pb-3">
      <div class="col">
        <button type="button" class="btn btn-info text-white w-50">
          Google Girişi
        </button>
      </div>
    </div>
    <div class="row pb-3">
      <div class="col">
        <h6 class="my-auto">Veya</h6>
      </div>
    </div>
    <div class="row pb-3">
      <div class="col">
        <input
          v-model="GirisBilgileri.email"
          type="email"
          class="form-control w-50 mx-auto"
          id="floatingInput"
          placeholder="E-Mail"
        />
      </div>
    </div>
    <div class="row pb-3">
      <div class="col">
        <input
          v-model="GirisBilgileri.sifre"
          type="password"
          class="form-control w-50 mx-auto"
          id="floatingPassword"
          placeholder="Parola"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button
          type="button"
          class="btn btn-info text-white w-50 mx-auto"
          :disabled="!GirisBilgileri.email || !GirisBilgileri.sifre"
        >
          Kayıt Ol
        </button>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col">
        <router-link to="giris"> Friendsquads'a giriş yap </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    GirisBilgileri: {
      email: "",
      sifre: "",
    },
  }),
};
</script>

<style>
#logo {
  font-size: 8vh;
}
#slogan {
  font-size: 28px;
}
.form-control:focus,
.form-control:active {
  border: 1px solid #0dcaf0;
  box-shadow: none !important;
  /* border-color: #0dcaf0 3px solid;
  outline: #0dcaf0 !important; */
}
</style>
